import {Injectable} from '@angular/core';

import {StoreConfig} from '@datorama/akita';
import {GridColumn, GridStore} from '@q9elements/ui-kit/components';
import {ICustomViewColumn} from '../../../models/custom-view.interface';

import {CustomMetadataEntity} from './custom-metadata-entity';

export type CustomMetadataColumn = ICustomViewColumn & GridColumn<any>;

@Injectable({providedIn: 'root'})
@StoreConfig({name: 'custom-metadata', idKey: '_id', resettable: true})
export class CustomMetadataStore extends GridStore<CustomMetadataEntity> {
  constructor() {
    super({
      columns: [] as CustomMetadataColumn[]
    });
  }
}
